
<template>
    <div class="container pb-4 mb-4">

<div class="row">
            <div class="col d-md-none d-none d-md-table"><h5 class="mb-3">Campaigns</h5></div>
            <div v-if="campaigns.length > 0" class="col text-right pt-1 mb-md-0 mb-3 text-center text-md-right">
              <i class="fas fa-plus-circle mr-2"></i><a href="/campaigns/new">New campaign</a>
          </div>
      </div>

  <div class="card">
    <div class="card-body pb-0">

      <div v-if="loading" class="text-center pt-2 pb-4"><i class="fas fa-spinner fa-spin"></i></div>

      <div v-else-if="campaigns.length == 0" class="text-center pb-3">
            <a href="/campaigns/new" class="btn btn-danger px-3">Create new campaign</a>
      </div>

        <div v-else>

          <div class="text-center pb-3">
            <select class="date-range" v-model="filter" @change="getCampaigns()">
                <option v-for="(status, index) in statuses" :key="index" :value="status">{{status}}</option>
            </select>
            <span v-if="loadingFilter" class="date-range-text"><i class="fas fa-spinner fa-spin"></i></span>
            <span v-else-if="rangeText" class="date-range-text">{{rangeText}}</span>
          </div>

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="28%">Name</th>
                  <th class="pl-3" width="14%">Status</th>
                  <th class="pl-3" width="14%">Views</th>
                  <th class="pl-3" width="14%">Clicks</th>
                  <th class="pl-3" width="14%">Click Rate</th>
                  <th class="first-right pl-3" width="16%">Action</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(campaign, index) in campaigns" :key="index.id">
              <td class="pl-3"><a :href="`/campaigns/view/${campaign.id}`">{{campaign.name}}</a></td>
              <td class="pl-3">
                <i v-if="campaign.status == 'Active'" class="fas fa-circle" style="color:green;font-size:17px;" :title="campaign.status"></i>
                <i v-else class="fas fa-circle" style="color:red;font-size:17px;" :title="campaign.status"></i>
                </td>
              <td class="pl-3">{{campaign.views}}</td>
              <td class="pl-3">{{campaign.clicks}}</td>
              <td class="pl-3">{{calculateRate(campaign.clicks,campaign.views)}}</td>
              <td class="pl-3">
                <a :href="`/campaigns/view/${campaign.id}`" class="mr-3" title="View campaign"><i class="fas fa-eye"></i></a>
                <a :href="`/campaigns/new?edit=true&campaign_id=${campaign.id}`" class="mr-3" title="Edit campaign"><i class="fas fa-edit"></i></a>
                <a href="#/" @click="showModalCampaignStatus(campaign)" title="Update status"><i class="fas fa-toggle-on"></i></a>
              </td>       
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Campaign • Views • Clicks</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body" v-for="(campaign, index) in campaigns" :key="index">
  
        <td class="pl-2 text-center">
            <div class="pt-2">{{campaign.name}}</div>
            <div>Status: {{campaign.status}}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
  </div>
  <campaign-status :campaign="selectedCampaign"></campaign-status>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      filter: 'Today',
      campaigns: [],
      loading: true,
      selectedCampaign: {},
      statuses: ['Today', 'Yesterday','This week','Last week','This month','Last month','This year','Last year','All time'],
      rangeText: null,
      loadingFilter: false,
    };
  },

  created() {
    this.getCampaigns();

    EventBus.$on('campaign-status-updated', () => {
      this.getCampaigns();
    });
  },

  methods: {
    showModalCampaignStatus(campaign) {
      this.selectedCampaign = campaign;
      this.$bvModal.show(`bv-modal-campaign-status`);
    },

    getCampaigns() {

      this.loadingFilter = true;

      axios.post(`/campaigns/list`, {
        filter: this.filter,
      }).
      then((response) => {
        this.campaigns = response.data.campaigns;
        this.rangeText = response.data.rangeText
      }).
      catch((error) => {
        this.sweetfire(error.response.data.message);
      }).finally(() => {
        this.loading = false;
        this.loadingFilter = false;
      });

    },

    

  },
};
</script>